import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Table, Button, Label } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { forEach as _forEach, find as _find } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { getDefaultImageFromEntity, getThumbFileFromEntity } from 'helpers/items';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { getColorForString } from 'helpers/charts';

import Entity from 'components/Entity';
import List from 'components/List';
import Data from 'components/Data';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import AttributeValuesInline from 'components/layout/item/AttributeValuesInline';
import SimplePrompt from 'components/layout/SimplePrompt';

import VariantNew from 'components/modals/VariantNew';

import { entityMetaMapping, ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';

class ItemVariants extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit: false,
      editedVariant: null,
      shownVariant: null,
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();

    if (
      props.meta.ItemVariantsList !== undefined &&
      props.meta[entityMetaMapping.itemVariant] !== undefined &&
      !props.meta[entityMetaMapping.itemVariant].pending
    ) {
      this.entity.setMeta(props.meta, 'ItemVariantsList');
    }
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      meta,
      data,
      variantNewFormStatus,
      variantEditFormStatus,
      doNotify,
    } = this.props;

    // variant was saved to the item
    if (prevProps.variantNewFormStatus.pending && !variantNewFormStatus.pending && !variantNewFormStatus.hasError) {
      this.closeNew();
      doNotify(1, messages.variant_saved);
    }

    // variant was saved to the item
    if (prevProps.variantEditFormStatus.pending && !variantEditFormStatus.pending && !variantEditFormStatus.hasError) {
      this.closeEdit();
      doNotify(1, messages.variant_saved);
    }

    if (prevProps.data.data.list.length !== data.data.list.length) {
      this.entity.setData({ list: data.data.list });
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData({ list: data.data.list });
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (
      meta[entityMetaMapping.itemVariant] !== undefined &&
      !meta[entityMetaMapping.itemVariant].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, 'ItemVariantsList');
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  handleClick = variantId => {
    this.props.history.push(
      this.props.appIntl.urlPrefix + 'account/items/' + this.props.itemEntity.getId() + '/variants/' + variantId
    );
  };

  handleRemoveClick = (e, variantId) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.deleteVariant(this.props.itemEntity.getId(), variantId);
  };

  render() {
    const {
      intl: { messages },
      itemEntity,
      itemEntityLoaded,
      appIntl,
      data,
      user,
    } = this.props;

    const { shownIndex, entityLoaded, entity } = this.state;

    const columns = [messages.image];
    columns.push(<i className="fa fa-eye" />);
    let variantAttributes;
    if (itemEntityLoaded) {
      variantAttributes = itemEntity.getVariants().getAttributes();
      if (variantAttributes !== null) {
        _forEach(variantAttributes, variantAttribute => {
          columns.push(getNameInCurrentLanguage(variantAttribute.getName(), appIntl));
        });
      }
    }
    columns.push(messages.price);
    columns.push(messages.identification);
    columns.push(messages.actions);
    let tBody = [];
    if (entityLoaded && entity && entity.getList().length) {
      const variants = entity.getList();

      tBody = variants.map((variant, i) => {
        const variantAttributeCells = [];

        if (variantAttributes !== null) {
          _forEach(variantAttributes, (variantAttribute, i) => {
            // attributes that define a variant
            const thisVariantAttribute = _find(variant.getAttributes(), ['id', variantAttribute.getId()]); // attribute value for current variant
            variantAttributeCells.push(
              <td class="v-align-middle" key={i}>
                <IntlFormInlineSelector />

                {thisVariantAttribute === undefined ? (
                  <Label bsStyle="warning">{messages.no_value_set}</Label>
                ) : (
                  <span style={{ color: '#' + getColorForString(variantAttribute.getId()) }}>
                    <AttributeValuesInline values={thisVariantAttribute.getValues()} />
                  </span>
                )}
              </td>
            );
          });
        }

        const defaultImage = getDefaultImageFromEntity(variant);
        let defaultImageThumb;
        if (defaultImage !== undefined) {
          defaultImageThumb = getThumbFileFromEntity(defaultImage);
        }

        return (
          <tr
            key={i}
            class={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(variant.getId());
            }}
          >
            <td class="v-align-middle">
              {defaultImageThumb !== undefined && (
                <img src={defaultImageThumb.getWebLink()} style={{ width: '100px' }} />
              )}
            </td>
            <td class="v-align-middle">
              <i class={'fa fa-eye' + (variant.getIsActive() ? '' : '-slash')} />
            </td>
            {variantAttributeCells}
            <td class="v-align-middle">
              {!!variant.getPricing().getPrice() && (
                <FormattedNumber
                  value={variant.getPricing().getPrice()}
                  style="currency"
                  currency={variant.getPricing().getCurrency()}
                />
              )}
            </td>
            <td class="v-align-middle">
              {!!variant.getIdent().getSku() && (
                <span>
                  <span class="hint-text">{messages.sku}:</span> {variant.getIdent().getSku()}
                </span>
              )}
              {!!variant.getIdent().getSku() && !!variant.getIdent().getUpc() && <br />}
              {!!variant.getIdent().getUpc() && (
                <span>
                  <span class="hint-text">{messages.upc}:</span> {variant.getIdent().getUpc()}
                </span>
              )}
            </td>
            <td class="v-align-middle text-right">
              <Button bsSize="sm" class="btn-rounded m-r-10">
                <i class="fa fa-pencil-alt" /> {messages.edit}
              </Button>
              {may(ROLE_ERP_MASTER, user.roles) && (
                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, variant.getId());
                  }}
                />
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {itemEntityLoaded && itemEntity.getVariants().getAttributes().length > 0 ? (
          <Row>
            {itemEntity.getId() !== null && (
              <List
                noRender
                listName="itemVariants"
                url={'/api/items/' + itemEntity.getId() + '/variants.json'}
                list={data}
              />
            )}
            <Data dataName="itemVariant" />

            <Col xs={12}>
              <Table responsive hover>
                <thead>
                  <tr>
                    {columns.map((column, i) => {
                      return (
                        <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>

              <div class="m-t-10">
                <Button onClick={this.showNew}>{messages.add_variant}</Button>
              </div>
            </Col>
          </Row>
        ) : null}

        {itemEntityLoaded && itemEntity.getVariants().getAttributes().length === 0 && (
          <Row>
            <Col xs={12}>You must define attributes to create variants.</Col>
          </Row>
        )}

        <VariantNew item={itemEntity} show={this.state.showNew} close={this.closeNew} />
      </div>
    );
  }
}
ItemVariants.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.list.itemVariants,
    meta: state.entityMeta,
    variantNewFormStatus: state.formStatus.variantNew,
    variantEditFormStatus: state.formStatus.variantEdit,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteVariant: (itemId, variantId) => {
      deleterDispatchHelper('variant', '/api/items/' + itemId + '/variants/' + variantId + '.json', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ItemVariants)
  )
);
